import { render, staticRenderFns } from "./proReviewExam97.vue?vue&type=template&id=809d1344&scoped=true&"
import script from "./proReviewExam97.vue?vue&type=script&lang=js&"
export * from "./proReviewExam97.vue?vue&type=script&lang=js&"
import style0 from "./proReviewExam97.vue?vue&type=style&index=0&id=809d1344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809d1344",
  null
  
)

export default component.exports